<template>
    <base-field 
        :annotation="annotation" 
        :scale="scale"
        :selected="selected"
        :editable="editable"
        @field-click="handleClick"
        @position-change="$emit('position-change', $event)"
    >
        <div class="text-field-display">
            <textarea
                v-if="editing && annotation.properties.multiline"
                v-model="localValue"
                :placeholder="annotation.properties.placeholder || annotation.label || annotation.fieldName || 'Enter text...'"
                :maxlength="annotation.properties.maxLength"
                @blur="handleBlur"
                @keydown.escape="handleEscape"
                ref="textInput"
                class="text-input textarea-input"
            ></textarea>
            <input
                v-else-if="editing"
                type="text"
                v-model="localValue"
                :placeholder="annotation.properties.placeholder || annotation.label || annotation.fieldName || 'Enter text...'"
                :maxlength="annotation.properties.maxLength"
                @blur="handleBlur"
                @keydown.escape="handleEscape"
                @keydown.enter="handleBlur"
                ref="textInput"
                class="text-input"
            />
            <div v-else class="text-display" :class="{ 'has-value': !!value }">
                <span v-if="value">{{ value }}</span>
                <span v-else class="placeholder-text">
                    <i class="fa fa-font"></i>
                    {{ annotation.label || annotation.properties.placeholder || annotation.fieldName || 'Text field' }}
                </span>
            </div>
        </div>
    </base-field>
</template>

<script>
import Vue from 'vue';
import BaseField from './BaseField.vue';

export default {
    name: 'TextField',
    components: { BaseField },
    props: {
        annotation: {
            type: Object,
            required: true
        },
        value: {
            type: String,
            default: ''
        },
        scale: {
            type: Number,
            default: 1
        },
        selected: {
            type: Boolean,
            default: false
        },
        editing: {
            type: Boolean,
            default: false
        },
        editable: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            localValue: this.value || ''
        };
    },
    watch: {
        value(newValue) {
            this.localValue = newValue || '';
        },
        editing(isEditing) {
            if (isEditing) {
                this.$nextTick(() => {
                    const input = this.$refs.textInput;
                    if (input) {
                        input.focus();
                        input.select();
                    }
                });
            }
        }
    },
    methods: {
        handleClick() {
            if (!this.editing) {
                this.$emit('field-click', this.annotation);
            }
        },
        
        handleBlur() {
            this.$emit('value-change', this.annotation.fieldName, this.localValue);
            this.$emit('edit-end', this.annotation);
        },
        
        handleEscape() {
            this.localValue = this.value || '';
            this.$emit('edit-end', this.annotation);
        }
    }
};
</script>

<style scoped>
.text-field-display {
    width: 100%;
    height: 100%;
}

.text-input {
    width: 100%;
    height: 100%;
    border: none;
    outline: none;
    background: transparent;
    font-size: 14px;
    padding: 4px;
    resize: none;
}

.textarea-input {
    min-height: 60px;
}

.text-display {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 4px;
    background-color: #fff;
    border: 1px dashed #ccc;
    border-radius: 4px;
    font-size: 14px;
}

.text-display.has-value {
    border: 1px solid #e2e8f0;
}

.placeholder-text {
    color: #718096;
    font-style: italic;
    display: flex;
    align-items: center;
    gap: 8px;
}

.placeholder-text i {
    font-size: 12px;
}
</style>